import { Container } from "react-bootstrap";

function StrategyOverviewPage() {
    return (
    <Container>
        <h4> StrategyOverviewPage </h4>
    </Container>)
}

export default StrategyOverviewPage;